import React, { FC, useRef } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps, useSelector } from 'react-redux';

import { RootState } from '../../../../init-store';
import {
    getPageClassNameSelector,
    isMessengerIntegration,
    selectIsGlobalBarEnabled,
    selectIsTeleMessenger,
} from '../../features/config/selectors';
import { PremiumButtonHeader } from '../../features/root/root-container/components/default-view/components/premium-button-header';
import { getPremiumButtonEnabled } from '../../features/root/selectors';
import Footer from '../footer';
import style from './start-screen-layout.css';

const mapState = (state: RootState) => ({
    isMessengerIntegration: isMessengerIntegration(state),
    selectIsTeleMessenger: selectIsTeleMessenger(state),
    pageClassName: getPageClassNameSelector(state),
    isTeleMessenger: selectIsTeleMessenger(state),
});

const connector = connect(mapState);
type StartScreenLayoutConnectedProps = ConnectedProps<typeof connector>;

const StartScreenLayout: FC<StartScreenLayoutConnectedProps> = ({
    children,
    isMessengerIntegration,
    pageClassName,
    isTeleMessenger,
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const isGlobalBarEnabled = useSelector(selectIsGlobalBarEnabled);
    const isPremiumButtonEnabled = useSelector(getPremiumButtonEnabled);
    return (
        <div
            ref={ref}
            className={cn(style.root, pageClassName, {
                [style.withGlobalBar]: isGlobalBarEnabled,
                [style.withPremiumButton]: isPremiumButtonEnabled,
            })}
        >
            {isPremiumButtonEnabled && <PremiumButtonHeader />}
            {!isGlobalBarEnabled && <div className={cn(style.buffer, style.unresizable)} />}
            {children}
            {!isGlobalBarEnabled && <div className={cn(style.buffer, style.unresizable)} />}
            {!isGlobalBarEnabled && <div className={cn(style.buffer, style.resizable)} />}
            {isPremiumButtonEnabled && <div className={cn(style.buffer, style.spacer)} />}
            {!isMessengerIntegration && !isTeleMessenger ? <Footer /> : null}
        </div>
    );
};

export default connector(StartScreenLayout);
